var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-img',{staticClass:"mx-auto",attrs:{"height":"150","width":"150","src":_vm.src}}),_vm._v(" "),_c('div',{staticClass:"text-center mt-4",attrs:{"data-test":"empty-plug-text"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }